import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const ADMIN_API = `${BACKEND_URL}/api/admin`;
const TOKEN_KEY = "autopiecemalin_admin_token_v1";

export const getAdminToken = () => {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
};
export const setAdminToken = (t) => {
  try {
    localStorage.setItem(TOKEN_KEY, t);
  } catch {
    /* ignore */
  }
};
export const clearAdminToken = () => {
  try {
    localStorage.removeItem(TOKEN_KEY);
  } catch {
    /* ignore */
  }
};

const adminAxios = axios.create({ baseURL: ADMIN_API });
adminAxios.interceptors.request.use((config) => {
  const token = getAdminToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const adminLogin = (email, password) =>
  axios.post(`${ADMIN_API}/login`, { email, password }).then((r) => r.data);

export const adminMe = () => adminAxios.get("/me").then((r) => r.data);

export const adminLogout = () =>
  adminAxios.post("/logout").catch(() => null).finally(clearAdminToken);

export const fetchOverview = () =>
  adminAxios.get("/stats/overview").then((r) => r.data);

export const fetchTimeseries = (days = 30) =>
  adminAxios.get(`/stats/timeseries?days=${days}`).then((r) => r.data);

export const fetchProfitability = (days = 30) =>
  adminAxios.get(`/stats/profitability?days=${days}`).then((r) => r.data);

export const fetchAdminSuppliers = () =>
  adminAxios.get("/suppliers").then((r) => r.data);

export const updateSupplierCommission = (id, patch) =>
  adminAxios.patch(`/suppliers/${id}`, patch).then((r) => r.data);

export const listOrders = (params = {}) =>
  adminAxios.get("/orders", { params }).then((r) => r.data);

export const createOrder = (payload) =>
  adminAxios.post("/orders", payload).then((r) => r.data);

export const updateOrder = (id, patch) =>
  adminAxios.patch(`/orders/${id}`, patch).then((r) => r.data);

export const deleteOrder = (id) =>
  adminAxios.delete(`/orders/${id}`).then((r) => r.data);

export const exportClicksCsvUrl = () => `${ADMIN_API}/clicks?format=csv`;

export const fetchClicks = (limit = 500) =>
  adminAxios.get(`/clicks?limit=${limit}`).then((r) => r.data);

// Blog Admin
export const fetchBlogStats = () => adminAxios.get("/blog/stats").then((r) => r.data);
export const fetchBlogAdminArticles = (status) =>
  adminAxios.get("/blog/articles", { params: status ? { status } : {} }).then((r) => r.data);
export const fetchBlogAdminArticle = (id) =>
  adminAxios.get(`/blog/articles/${id}`).then((r) => r.data);
export const createBlogArticle = (payload) =>
  adminAxios.post("/blog/articles", payload).then((r) => r.data);
export const updateBlogArticle = (id, payload) =>
  adminAxios.put(`/blog/articles/${id}`, payload).then((r) => r.data);
export const approveBlogArticle = (id) =>
  adminAxios.post(`/blog/articles/${id}/approve`).then((r) => r.data);
export const rejectBlogArticle = (id, reason) =>
  adminAxios.post(`/blog/articles/${id}/reject`, { reason }).then((r) => r.data);
export const publishBlogArticle = (id) =>
  adminAxios.post(`/blog/articles/${id}/publish`).then((r) => r.data);
export const unpublishBlogArticle = (id) =>
  adminAxios.post(`/blog/articles/${id}/unpublish`).then((r) => r.data);
export const deleteBlogArticle = (id) =>
  adminAxios.delete(`/blog/articles/${id}`).then((r) => r.data);
